import { Tokens, initConfig as initCommon } from '@waitroom/common';
import { initConfig as initApi } from '@waitroom/common-api';
import { errorService, logger } from '@waitroom/error-service';
import { storageKeys } from '@waitroom/models';
import { config } from '.';
import { sentryService } from '../services/sentry';
import { storageService } from '../services/storage';
import { getFingerPrint } from '../utils/finger-print';
import { getClientDetails } from './clientDetails';
const getFP = getFingerPrint();

// setup logger
logger.enabled = config.customEnv !== 'production';
logger.cl(`ENV: ${config.customEnv}`);
// setup sentry and error service
sentryService.init();

// init api config
initApi({
  baseURL: config.domains.wormhole,
  version: 'v1.0',
  getAuthToken: () =>
    storageService.getParsed<Tokens>(storageKeys.AUTH_TOKENS)?.accessToken ||
    '',
  getFingerPrint: getFP,
  getClientDetails,
});

// init common config
initCommon({
  domains: {
    trixta: config.trixta.domain,
    luxor: config.domains.luxor,
    wormhole: config.domains.wormhole,
  },
  featureFlags: config.featureFlags,
  getFingerPrint: getFP,
  getClientDetails: getClientDetails(),
  storage: storageService,
  dateTime: config.dateTime,
  reportError: errorService.report,
  session: {
    maxSpeakers: config.session.maxSpeakers,
  },
});
